export var defaultLoadingClass = 'lazy-image--loading';
